import styled from 'styled-components';
const SystemMessageItem = styled.div.attrs(() => ({
  'data-test-id': 'system-message-item'
})).withConfig({
  displayName: "SystemMessageItem",
  componentId: "sc-63owxl-0"
})(["display:flex;justify-content:flex-start;align-items:center;width:100%;position:relative;padding:0 14px 0 18px;"]);
SystemMessageItem.displayName = 'SystemMessageItem';
export default SystemMessageItem;